import type { SendExpertAssistMessage } from "@expert/shared-types";
import { Button, Group, Text } from "@mantine/core";
import { useReactAnalytics } from "@soluto-private/eventualize-react";

import type { JSX } from "react";

interface AskAssistProps {
    prompt: string;
    sendMessage: SendExpertAssistMessage;
    extraData?: Record<string, unknown>;
}

export function AskAssist({ prompt, sendMessage, extraData }: AskAssistProps): JSX.Element | null {
    const { dispatcher } = useReactAnalytics();

    const onClick = () => {
        void dispatcher.dispatchBusinessEvent(`Click_Guide_AskAssist`, {
            button: "AskAssist",
            prompt,
            ...extraData,
        });
        sendMessage({
            text: prompt,
            type: "Expert",
            source: "GuideAskAssist",
        });
    };

    return (
        <Group gap="xxs">
            <Text c="dark.0" size="xs">
                Need help?
            </Text>
            <Button bg="transparent" onClick={onClick} p="0" size="xs">
                <Text c="dark.0" size="xs" td="underline">
                    Ask Assist
                </Text>
            </Button>
        </Group>
    );
}
